import React, {useState} from 'react';
import {SingleDatePicker} from "react-dates";

const DatePicker = ({date, onChange}) => {

    const [focused, setFocused] = useState(false);

    return (
        <div className="d-block">
            <SingleDatePicker
                readOnly={true}
                keepOpenOnDateSelect={false}
                hideKeyboardShortcutsPanel={true}
                openDirection={'up'}
                numberOfMonths={1}
                date={date}
                displayFormat={() => "DD/MM/YYYY"}
                onDateChange={(date) => onChange(date)}
                focused={focused}
                onFocusChange={(f) => setFocused(f.focused)}
            />
        </div>
    );
}

export default DatePicker;
